import React from 'react';
import { TextInput, View, type TextInputProps } from 'react-native';

import { getFontFamily, useThemePalette } from '@/config/theme';
import { useLocale } from '@/lib/i18n/LocaleProvider';

import { AppText } from './AppText';

export interface TextFieldProps extends TextInputProps {
  label?: string;
  errorText?: string;
  className?: string;
}

export function TextField({ label, errorText, className, style, ...rest }: TextFieldProps) {
  const palette = useThemePalette();
  const { locale, isRTL } = useLocale();
  return (
    <View className={className}>
      {label ? (
        <AppText variant="caption" weight="medium" className="mb-1.5 text-ink">
          {label}
        </AppText>
      ) : null}
      <TextInput
        placeholderTextColor={palette.muted}
        className={`rounded-2xl border bg-surface px-4 py-3.5 text-base text-ink ${
          errorText ? 'border-loss' : 'border-line'
        }`}
        style={[
          { fontFamily: getFontFamily(locale, 'regular'), textAlign: isRTL ? 'right' : 'left' },
          style,
        ]}
        {...rest}
      />
      {errorText ? (
        <AppText variant="micro" className="mt-1.5 text-loss">
          {errorText}
        </AppText>
      ) : null}
    </View>
  );
}
